module.exports = __webpack_public_path__ + "img/u205.6deee65c.jpg";